import domReady from '@wordpress/dom-ready';

domReady(async () => {
	const intercomLoadedEvent = new Event('IntercomLoaded', { bubbles: true });
	const { IntercomHelper } = await import('./intercom-helper');
	const intercomContainerSelector = '.intercom-app';
	const intercomWidgetSelector = '.intercom-launcher';

	const helper = new IntercomHelper({
		intercomLoadedEvent,
		intercomContainerSelector,
		headerJsClass: '.js-header',
		openIntercomButtonClass: '.js-contact-button',
		intercomWidgetSelector,
		gdprModalSelector: '.js-gdpr-modal',
		activeSelector: '.is-active',
		intercomModalMargin: 20,
		intercomOffsetOnViewportsNarrowerThan: 780,
		intercomOffsetFor: 100,
	});

	helper.init();

	const timeout = setTimeout(() => clearInterval(interval), 30000);
	const interval = setInterval(() => {
		const intercomContainer = document.querySelector(intercomContainerSelector);
		const intercomWidget = document.querySelector(intercomWidgetSelector);

		if (window.Intercom?.booted && (intercomContainer || intercomWidget)) {
			intercomWidget?.dispatchEvent(intercomLoadedEvent);

			if (!intercomWidget) {
				intercomContainer?.dispatchEvent(intercomLoadedEvent);
			}
			clearInterval(interval);
			clearTimeout(timeout);
		}
	}, 100);
});
